import React from "react";
import { Container, Text, Space } from "@mantine/core";
import { Modal } from "../Modal/Modal";
import { Title } from "../Title/Title";
import { NumberedList } from "../NumberedList/NumberedList";
import { BannerExample } from "../BannerExample/BannerExample";

type ModalReturnInstructionsProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
};

export const ModalReturnInstructions: React.FC<
  ModalReturnInstructionsProps
> = ({ ...props }: ModalReturnInstructionsProps) => {
  return (
    <Modal
      dataTestId="modal-return-instructions"
      isOpen={props.isOpen}
      variant={{
        type: "VALIDATION",
        buttonText: "Voir ma commande",
        onClose: props.onClose,
      }}
      withCloseButton={false}
      buttonPosition="center"
      size="xl"
      padding="xl"
    >
      <Container
        style={{
          display: "flex",
          flexDirection: "column",
          alignContent: "center",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Title
          size={2}
          variant="primary"
          title="Les prochaines étapes de votre commande"
        />
        <Space h="lg" />
        <Title size={2} variant="success" title={props.title} />
        <Space h="md" />
        <NumberedList
          list={[
            {
              title:
                "Faites l’essayage du montage dents sur cire en bouche. Testez aussi bien l’adaptation que l’esthétique.",
            },
            {
              title:
                "Sur la page Détail de la commande, cliquez sur la bannière pour demander notez vos commentaires et demander une étiquette de retour.",
              description:
                "Vous pourrez décider à ce moment si vous souhaitez poursuivre vers la finition ou faire un nouvel essayage.",
              children: (
                <BannerExample>Essayez le montage dents en cire</BannerExample>
              ),
            },
            {
              title:
                "Si vous constatez un problème d’adaptation, de mordu, de DVO ou de forme des dents, il faudra prendre une nouvelle empreinte.",
            },
            {
              title:
                "Prévoyez votre prochain RDV patient et Jasper s’occupe du reste.",
            },
          ]}
        />
      </Container>
    </Modal>
  );
};
